import { gql } from '@zenbusiness/application-commons-graphql';

import { ATTRIBUTES_FRAGMENT } from '../fragments/AttributesFragment';
import { UI_INSTRUCTION_FRAGMENT } from '../fragments/UiInstructionFragment';

export const CREATE_THREAD_MUTATION = gql`
  mutation CreateThread($identity: Identity!, $input: JSON!, $threadMode: ThreadMode) {
    createThread(identity: $identity, input: $input, threadMode: $threadMode) {
      ok
      threadUuid
      data {
        id
        type
        attributes {
          ...AttributesFragment
        }
        meta {
          renderStrategy
        }
      }
      error
      meta
    }
  }
  ${ATTRIBUTES_FRAGMENT}
  ${UI_INSTRUCTION_FRAGMENT}
`;
